import type { FaireProductEntity } from "../../entity_types/product";

export const p_x6kh4xrxe7: FaireProductEntity = {
  token: "p_x6kh4xrxe7",
  type: "product",
  name: "Game Day Shoe Chain with Assorted Charms",
  brandToken: "b_vswk7rntc2",
  brandName: "SP Sophia Collection",
  imageUrl: "https://cdn.faire.com/fastly/db048961cd44d2797d49a5437e2ba18e3a8c2abeb0358d5bc9acde62ff92093f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4c66e7c2a62f910c445064ef6b8269ff364976dab2ee64103f0dc0d33f75abe.jpeg",
    "https://cdn.faire.com/fastly/b56e3203e3a9654ffc74fbb9327c44b5d2c0e6524224cf51132cb08d373f1669.jpeg",
    "https://cdn.faire.com/fastly/9dc41e251f5dda1cac6bf94b47a476b146cf0e5883369504a156998b0d8dc602.jpeg",
    "https://cdn.faire.com/fastly/ed87f429831d03495256c618a57afacf6bc11c0c8dfab8cfff9d48f8e8dfc1bb.jpeg",
    "https://cdn.faire.com/fastly/88f5e506c4b061446891c454b260d9b855d0942236dd2d8445df37ff51bd03b1.jpeg",
    "https://cdn.faire.com/fastly/5e7636168f9764d7e161ddd7763a91af273b6ba6b169c46ca697997fdf6fe11a.jpeg"
  ],
  priceDollars: 6.6,
  description: "Measurements:\nChain Length: 5\"\nDrop Length: 0.5\"\nCharm Dimensions: Height: 0.75\"–1.75\"\nWidth: 0.6\"–1.6\"\n\nKey Features\nStep up your spirit wear with this game day shoe chain, featuring a bold lineup of enamel and metal charms designed to celebrate school pride, sports enthusiasm, and fan energy. The lightweight chain links securely across your laces or around your footwear, offering a unique and adjustable fit. Charms include themed icons and playful shapes that add flair and personality with every step.\n\nPerfect For\nCheerleaders, students, and sports fans looking to accessorize sneakers or boots for rallies, homecoming, tailgates, and tournaments. Great for school spirit weeks, athletic events, or as a standout accessory for dance lines, pep squads, and game day fashionistas.",
  tags: [],
  msrpDollars: 26.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:10.696Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
